// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CEWhH","card_container":"styles_card_container__8B8tU","image_icon":"styles_image_icon__3FivK"};